import React, { useContext } from 'react';
import { useFieldContext } from '../field/context';

export const ControlContext = React.createContext({ status: 'default' });

/**
 *
 * @type {import('../field').UseFieldContextType}
 */
export const useControlContext = ({ ...props }) => {
  const fieldContext = useFieldContext(props);
  const context = useContext(ControlContext);
  return {
    ...fieldContext,
    ...context,
    ...props,
  };
};

export default ControlContext;
